import { useState, useMemo } from "react";
import SearchBar    from "./SearchBar";
import TabBar       from "./TabBar";
import ChatListItem from "./ChatListItem";
 
export default function ChatSidebar({ chats, activeChat, onSelectChat }) {
  const [query, setQuery]       = useState("");
  const [activeTab, setActiveTab] = useState("All");
 
  // Total unread for Unread tab badge
  const totalUnread = chats.reduce((n, c) => n + (c.unread || 0), 0);
 
  // Filter list by search query + active tab
  const filtered = useMemo(() => {
    return chats.filter((c) => {
      const matchesSearch = c.name.toLowerCase().includes(query.toLowerCase());
      const matchesTab =
        activeTab === "All"    ? true :
        activeTab === "Unread" ? c.unread > 0 :
        activeTab === "Groups" ? c.isGroup :
        true;
      return matchesSearch && matchesTab;
    });
  }, [chats, query, activeTab]);
 
  return (
    <div style={styles.panel}>
      {/* ── Header ── */}
      <div style={styles.header}>
        <span style={styles.title}>Chats</span>
        {/* New chat icon */}
        <button style={styles.iconBtn} title="New chat">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="#1a3c5e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            <line x1="12" y1="9" x2="12" y2="15" />
            <line x1="9"  y1="12" x2="15" y2="12" />
          </svg>
        </button>
      </div>
 
      <SearchBar value={query} onChange={setQuery} />
      <TabBar
        activeTab={activeTab}
        onTabChange={setActiveTab}
        unreadCount={totalUnread}
      />
 
      {/* ── Scrollable list ── */}
      <div style={styles.list}>
        {filtered.length === 0 ? (
          <p style={styles.empty}>No chats found</p>
        ) : (
          filtered.map((chat) => (
            <ChatListItem
              key={chat.id}
              chat={chat}
              isActive={activeChat?.id === chat.id}
              onClick={onSelectChat}
            />
          ))
        )}
      </div>
    </div>
  );
}
 
const styles = {
  panel: {
    width: 300,
    minWidth: 260,
    borderRight: "1px solid #000000ff",
    display: "flex",
    flexDirection: "column",
    background: "#000000ff",
    height: "100%",
    flexShrink: 0,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 16px 10px",
    borderBottom: "1px solid #000000ff",
  },
  title: {
    fontSize: 17,
    fontWeight: 700,
    color: "#0f172a",
  },
  iconBtn: {
    background: "#f9f1f1ff",
    border: "none",
    borderRadius: 8,
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  list: {
    flex: 1,
    overflowY: "auto",
  },
  empty: {
    textAlign: "center",
    color: "#94a3b8",
    fontSize: 13,
    marginTop: 40,
  },
};
 